import { Navigate } from 'react-router-dom';

/** New category is created from the categories list via modal. */
export default function SeedVarietyCategoryNew() {
  return (
    <Navigate to="/admin/dashboard/seed-varieties/categories" replace state={{ openNewCategory: true }} />
  );
}
